import { config } from "./config";
// @ts-ignore
import useApi from "./ServiceClient.tsx";

export const usePermissionManagement = () => {
    const { GET, POST } = useApi(); // Use API methods inside a React hook

    const getAllPermissions = () => {
        const response = GET(config?.permission_management?.END_POINTS?.ALL_PERMISSION);
        return response;
    };

    const getAllPermissionCategory = () => {
        const response = GET(config?.permission_management?.END_POINTS?.ALL_CATE_PERMISSION);
        return response;
    };

    const getAllPermissionUserCategory = () => {
        const response = GET(config?.permission_management?.END_POINTS?.ALL_USER_CATE_PERMISSION);
        return response;
    };

    const createRole = (data) => {
        const response = POST(
            config?.permission_management?.END_POINTS?.CREATE_ROLE,
            data
        );
        return response;
    };

    const updateRole = (data) => {
        const response = POST(
            config?.permission_management?.END_POINTS?.UPDATE_ROLE,
            data
        );
        return response;
    };

    const getRoleById = (roleid) => {
        const response = GET(
            `${config?.permission_management?.END_POINTS?.GET_BY_ROLE_ID}/${roleid}`
        );
        return response;
    };

    const getAllRoles = async () => {
        const response = GET(config?.permission_management?.END_POINTS?.ALL_ROLES);
        return response;
    };

    const assignUserByRole = async (roleid, userid) => {
        const response = GET(
            `${config?.permission_management?.END_POINTS?.ASSIGN_USER_N_ROLE}/${roleid}/assign/${userid}`
        );
        return response;
    };

    const removeUserByRole = async (roleid, userid) => {
        const response = GET(
            `${config?.permission_management?.END_POINTS?.ASSIGN_USER_N_ROLE}/${roleid}/remove/${userid}`
        );
        return response;
    };

    return {
        getAllPermissions,
        getAllPermissionCategory,
        getAllPermissionUserCategory,
        createRole,
        updateRole,
        getRoleById,
        getAllRoles,
        assignUserByRole,
        removeUserByRole
    };
};
